import InputAutocompleteMulti from '../../components/StylovyzeForm/InputAutocompleteMulti';
import { useSelectPaginatedSensorGroups } from '@innovyze/stylovyze/lib/selectors';
import { useFormikContext } from 'formik';
import React from 'react';
export default function SensorGroupAutocomplete(props) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { setFieldTouched } = useFormikContext();
    const { sensorGroups } = useSelectPaginatedSensorGroups();
    const { autocompleteProps, textFieldProps, onChange, ...restOfProps } = props;
    const { name } = props.fieldAttrs;
    const sensorGroupsOptions = sensorGroups.map(sensorGroup => ({
        key: sensorGroup._id,
        value: sensorGroup.name,
    }));
    return (React.createElement(InputAutocompleteMulti, { label: 'Sensor groups' || props.label, textFieldProps: {
            onBlur: () => {
                setFieldTouched(name, true);
            },
            ...textFieldProps,
        }, onChange: e => {
            if (onChange)
                onChange(e);
            else
                setFieldTouched(name, true);
        }, autocompleteProps: {
            disableClearable: true,
            ...autocompleteProps,
        }, options: sensorGroupsOptions, ...restOfProps }));
}
